import React, { useEffect, useImperativeHandle, useLayoutEffect, useRef, useState } from 'react'
import { Form, Formik, FormikProps } from 'formik';
import { useDispatch } from 'react-redux';
import { updateIsResetForm } from '../../../store/slices/formHelperSlice';
import FormObserver from '../FormElements/FormObserver';
import { FormInput, FormSelector } from '../FormElements';
import { TbDots } from 'react-icons/tb';
import { isLogoAppProject } from '../../../common/helpers/globalHelpers';
import FormMultiSelect from '../FormElements/FormMultiSelect';
import { Button } from '../Elements';
import FormFiltersShortList from '../FormElements/FormFiltersShortList';
import { customerMatchStatus } from '../../../constants/options/customerMatchStatus';
import { OptionModel } from '../../../common/types/OptionModel';
import useFetchCityDistrict from '../../../hooks/useFetchCityDistrict';
import { ThunkDispatch } from 'redux-thunk';
import { FilterProps } from '../../../common/types/FilterProps';
import { getSelectedValueFromId } from '../../../common/helpers/selectBoxHelper';
import { buttonTexts } from '../../../constants/texts/buttonTexts';
import { getWebCustomerList } from '../../../store/slices/webCustomersSlice';

const initialValues = {
    customerCode: "",
    customerName: "",
    email: "",
    phone: "",
    city: [],
    district: [],
    isMatchToUser: []
}

const Filters = React.forwardRef<HTMLDivElement | any, FilterProps & { setFilterFormValues: any, setShowTable: any }>(({ isOpen, setFiltersIsOpen, selectedUser, tableSelectedRows, loadingStatus, page, pageSize, setFilterFormValues, setShowTable }, ref) => {

    // useRef's
    const formRef = useRef<FormikProps<typeof initialValues>>(null);

    // useState's
    const [formValues, setFormValues] = useState(initialValues);
    const [cityOptions, setCityOptions] = useState<OptionModel[]>([]);
    const [filteredDistrictOptions, setFilteredDistrictOptions] = useState<OptionModel[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    // useDispacth
    const dispacth = useDispatch<ThunkDispatch<any, any, any>>();
    const thunkdispatch = useDispatch<ThunkDispatch<any, any, any>>();

    // Resets the filter after the user is selected or the select is cleared
    useImperativeHandle(ref, () => ({
        resetForm: () => {
            formRef.current?.resetForm();
        },
        onSubmit: () => {
            formRef.current?.submitForm();
        }
    }));

    useEffect(() => {
    }, [isOpen]);

    useLayoutEffect(() => { }, []);

    useEffect(() => { }, []);

    useFetchCityDistrict(formValues.city, setCityOptions, setFilteredDistrictOptions);

    useEffect(() => {
        if (loadingStatus) {
            loadingStatus(loading);
        }
    }, [loading])

    const onSubmit = async (values: any) => {
        const parameters: any = {
            customername: values.customerName,
            customercode: values.customerCode,
            matchedUserType: values.isMatchToUser,
            isFromMatch: true,
            selectedMatchUser: selectedUser,
            phone: values.phone.replace(/[() ]/g, ""),
            email: values.email,
            cityIds: values.city.map((item: any) => item.value).join(","),
            districtIds: values.district.map((item: any) => item.value).join(","),
            status: true,
            pageNumber: 1,
            pageSize: pageSize
        }

        setFilterFormValues(parameters);
        setLoading(true);

        try {
            thunkdispatch(getWebCustomerList(parameters));
        } catch (error) {

        } finally {
            setFiltersIsOpen(false);
            setLoading(false);
            setShowTable(true);
        }
    };

    const clearFilters = () => {
        dispacth(updateIsResetForm(true));
        setTimeout(() => {
            dispacth(updateIsResetForm(false));
        }, 1000);
        formRef.current?.resetForm();
        submitForm();
    };

    const submitForm = () => {
        formRef.current?.submitForm();
    };

    const onUpdate = (value: any) => {
        setFormValues(Object.assign(formValues, value));
        submitForm();
    };

    const fields = [
        {
            key: "customerName",
            label: "Müşteri Adı",
            type: "text"
        },
        {
            key: "customerCode",
            label: "Müşteri Kodu",
            type: "text"
        },
        {
            key: "email",
            label: "Müşteri E-Posta Adresi",
            type: "text"
        },
        {
            key: "phone",
            label: "Müşteri Cep Telefonu",
            type: "text"
        },
        {
            key: "city",
            label: "Şehir",
            type: "multiselect",
            options: cityOptions
        },
        {
            key: "district",
            label: "İlçe",
            type: "multiselect",
            options: filteredDistrictOptions
        },
        {
            key: "isMatchToUser",
            label: "Bağlı Kullanıcı",
            type: "select",
            options: customerMatchStatus
        }
    ];

    return (
        <Formik
            innerRef={formRef}
            initialValues={initialValues}
            onSubmit={onSubmit}
        >
            {({
                values,
            }) => (
                <Form>
                    <FormObserver
                        watch={(val: any) => {
                            setFormValues(val);
                        }}
                    />
                    <div className={`m-3 px-4 py-2 bg-white shadow-md rounded-md ${!isOpen ? "hidden" : ""}`}>
                        <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-3 xl:grid-cols-4">
                            <div className="flex flex-col justify-start px-0">
                                <div className="mt-1">
                                    <FormInput
                                        label="Müşteri Adı"
                                        name="customerName"
                                        type="text"
                                        rightIcon={isLogoAppProject() && (
                                            <TbDots
                                                className="sm:block h-6 w-6 text-black hidden cursor-pointer"
                                                aria-hidden="true"
                                                color="#0090FF"
                                            />
                                        )}
                                    />
                                </div>
                                <div className="mt-2">
                                    <FormInput
                                        label="Müşteri Kodu"
                                        name="customerCode"
                                        type="text"
                                        rightIcon={isLogoAppProject() && (
                                            <TbDots
                                                className="sm:block h-6 w-6 text-black hidden cursor-pointer"
                                                aria-hidden="true"
                                                color="#0090FF"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col justify-start px-0">
                                <div className="mt-1">
                                    <FormInput
                                        label="Müşteri Cep Telefonu"
                                        name="phone"
                                        type="text"
                                        mask="(999) 999 99 99"
                                        rightIcon={isLogoAppProject() && (
                                            <TbDots
                                                className="sm:block h-6 w-6 text-black hidden cursor-pointer"
                                                aria-hidden="true"
                                                color="#0090FF"
                                            />
                                        )}
                                    />
                                </div>
                                <div className="mt-2">
                                    <FormInput
                                        label="Müşteri E-Posta Adresi"
                                        name="email"
                                        type="text"
                                        rightIcon={isLogoAppProject() && (
                                            <TbDots
                                                className="sm:block h-6 w-6 text-black hidden cursor-pointer"
                                                aria-hidden="true"
                                                color="#0090FF"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col justify-start px-0">
                                <div className='mt-1'>
                                    <FormMultiSelect
                                        options={cityOptions}
                                        name="city"
                                        placeholder="Şehir Seç"
                                        label="Şehir"
                                    />
                                </div>
                                <div className='mt-2'>
                                    <FormMultiSelect
                                        options={filteredDistrictOptions}
                                        name="district"
                                        placeholder="İlçe Seç"
                                        label="İlçe"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col justify-start px-0">
                                <div className='mt-1'>
                                    <FormSelector
                                        options={customerMatchStatus}
                                        name="isMatchToUser"
                                        placeholder='Bağlı kullanıcı durumunu seç'
                                        label="Bağlı Kullanıcı Durumu"
                                        value={getSelectedValueFromId(values.isMatchToUser, customerMatchStatus)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='flex justify-end mt-2 mr-0'>
                            <Button
                                type='button'
                                color='gray'
                                hover='gray'
                                size='xs'
                                className='mr-3'
                                callback={clearFilters}
                            >
                                <img src="/icons/delete-blue.svg" alt="deleteFilter" />
                                <span className='ml-3'>{buttonTexts.filterClear}</span>
                            </Button>
                            <Button type='submit' color='primary' hover='primary' size='xs' callback={() => { }} >
                                <img src="/icons/prepare-white.svg" alt="prepare" />
                                <span className='ml-3 mr-3'>{buttonTexts.filterSubmit}</span>
                            </Button>
                        </div>
                    </div>
                    <div className={`m-4 px-4 py-3 bg-white shadow-md rounded-md ${isOpen ? "hidden" : ""}`}>
                        <FormFiltersShortList
                            formValues={{
                                ...values
                            }}
                            fields={fields}
                            initialValues={initialValues}
                            callback={(val: any) => onUpdate(val)}
                            clearFilter={() => {
                                clearFilters();
                                submitForm();
                            }}
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
});

export default Filters;